import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../BaseComponents/Header";
import FotterMain from "../BaseComponents/FotterMain";
import { eventDetails } from "../../networkCalls";
import LoadingCellFullPage from "../LoadingCell/LoadingCellFullPage";
import parse from "html-react-parser";
import SEO from "../BaseComponents/SEO";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ReactPlayer from 'react-player'

const EventDetails = () => {
  const { pageSlug } = useParams();
  const [loading, setLoading] = useState(false);
  const [resultData, setResultData] = React.useState([]);
  const [nextarticle, setNextArticle] = React.useState(null);
  const [prevoiusarticle, setPreviousArticle] = React.useState(null);
  const eventDetailsAPI = () => {
    var data = new FormData();
    data.append("slug", pageSlug);
    setLoading(true);
    eventDetails(data).then((res) => {
      //console.log('dsfdf', res?.data?.eventDetails )
      setLoading(false);
      switch (res.data.status) {
        case 1:
          setResultData(res?.data?.eventDetails);
          setNextArticle(res?.data?.Sequence?.next);
          setPreviousArticle(res?.data?.Sequence?.previous);
          //setErrMessage('');
          return true;
        case 0:
          //setErrMessage(res.data.msz);
          break;
        default:
          return;
      }
    });
  };
  useEffect(() => {
    eventDetailsAPI();
  }, [pageSlug]);

  return (
    <>
      <SEO
        title="Honda India Power Products | Honda Events"
        description="Honda India Power Products Events"
        name="HIPP - Honda India Power"
        url="https://www.hondaindiapower.com/events"
        type="Website"
      />
      <Header />
      {loading ? (
        <>
          <LoadingCellFullPage />
        </>
      ) : (
        <>
          {" "}
          <div className="post-view__header post-header post-header--has-image">
            <div className=""></div>
            <div className="post-header__body">
              <div className="post-header__categories">
                <div className="post-header__categories-list">
                  <div className="post-header__categories-item mb-3">
                    <Link
                      className="post-header__categories-link text-white bgred rounded f12 p-2 pt-1 pb-1"
                      to="/events"
                    >
                      Events
                    </Link>
                  </div>
                </div>
              </div>
              <h3 className="post-header__title">{resultData?.title}</h3>
              <div className="post-header__meta">
                <ul className="post-header__meta-list">
                  <li className="post-header__meta-item">{resultData?.date}</li>
                </ul>
              </div>
            </div>
            <div className="decor decor--type--bottom post-header__decor">
              <div className="decor__body">
                <div className="decor__start"></div>
                <div className="decor__end"></div>
                <div className="decor__center"></div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-9  m-auto">
                <div className="post-view__body card rounded-0 border-0 shadow-sm p-4">
                  <div className="cm-content prscot">
                    <div className="d-flex justify-content-center align-items-center">
                      {prevoiusarticle !== null && (
                        <a href={`/${prevoiusarticle}`} className=" text-decoration-none txtred eentdetailsbtn  ">
                          <ArrowBackIosIcon className="eventdetailsarrow-left pointer f36" color="#CB1100"/>
                        </a>
                      )}
                      {
                        resultData?.video === null ? 
                      <img src={resultData?.image} alt="" className="w-90" />:
                       <ReactPlayer src={`https://www.youtube.com/embed/${resultData?.video}`} width="100%" height='460px' />

                      } 
                      {nextarticle !== null && (
                        <a href={`/${nextarticle}`} className=" text-decoration-none txtred eentdetailsbtn  ">
                          <ArrowForwardIosIcon className="eventdetailsarrow-right pointer f36" color="#CB1100"  />
                        </a>
                      )}
                    </div>
                    {/* <div className='mt-4'>{resultData?.description}</div> */}
                    <div className="mt-4">
                      {parse(`${resultData?.description}`)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <div style={{ clear: "both", height: "40px" }}></div>
      <FotterMain />
    </>
  );
};

export default EventDetails;
